query bookedCampaigns($companyId: ID!) {
  bookedCampaigns: bookedCampaigns(companyId: $companyId) {
    slug
  }
}
